import { Box, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import PlusMiniSvg from "../../../../media/images/icons/plus-mini";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import {
  changeSignupType,
  handleUserSignupTabbar,
} from "../../../../redux/features/settingSlice";

export default function ForgetPassLink() {
  const theme = useTheme();

  const userLoginTab = useAppSelector((state) => state.settings.userLoginTab);

  const dispatch = useAppDispatch();

  return (
    <Box
      sx={{
        marginTop: "24px",
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
      }}
    >
      <Typography>{"حساب کاربری ندارید؟"}</Typography>
      <Link
        onClick={() => {
          dispatch(changeSignupType("user"));
          dispatch(handleUserSignupTabbar(userLoginTab));
        }}
        to={"/signup"}
        style={{
          padding: 5,
          borderRadius: "5px",
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <PlusMiniSvg size={18} color={theme.palette.primary.main} />
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontWeight: 700,
          }}
        >
          ثبت نام جدید
        </Typography>
      </Link>
      
    </Box>
  );
}
